// extracted by mini-css-extract-plugin
export default {"mobile":"ljhAkhSjf0YRjSx91dVA"};